import axios from 'axios'
import { getValidConfig } from '../helpers/tokenManager.helper'

export async function getPrivacyConsentSummary (admin, token, clientId) {
  const config = await getValidConfig(admin, token)
  return await axios.get(`${process.env.REACT_APP_CONFIRMATION_API}privacy-consent/${clientId}/summary`, config)
}

export async function getPrivacyConsentRegistry (admin, token, clientId) {
  const config = await getValidConfig(admin, token)
  return await axios.get(`${process.env.REACT_APP_CONFIRMATION_API}privacy-consent/${clientId}/registry`, config)
}
